const { getOffsetTop } = window.BAO.Utils

class ParallaxImage extends window.BAO.CustomElement() {
  connectedCallback () {
    /* eslint-disable-next-line no-undef */
    if (Shopify.designMode) return

    // Respect reduced motion preferences
    const prefersReducedMotion = window.matchMedia(
      '(prefers-reduced-motion: reduce)',
    ).matches
    if (prefersReducedMotion) {
      this.setAttribute('active', '')
      return
    }

    super.connectedCallback()

    this.isTicking = false
    this.lastKnownY = window.scrollY

    this.requestTick = this.requestTick.bind(this)
    this.updateEl = this.updateEl.bind(this)

    this.updateEl()

    window.setTimeout(() => {
      this.setAttribute('active', '')
    }, 500)
  }

  setupListeners () {
    super.setupListeners()

    this.onScroll = this.onScroll.bind(this)

    window.addEventListener('scroll', this.onScroll, { passive: true })
  }

  onScroll () {
    this.lastKnownY = window.scrollY

    this.requestTick()
  }

  requestTick () {
    if (!this.isTicking) requestAnimationFrame(this.updateEl)

    this.isTicking = true
  }

  updateEl () {
    this.isTicking = false

    this.moveParallaxItem()
  }

  moveParallaxItem () {
    if (!this.offsetHeight) return

    const amountToMoveY = this.dataset.distanceY
      ? parseFloat(this.dataset.distanceY)
      : window.BAO.MediaBreakpoints.isXsViewport
        ? 30
        : 100
    const elementHeight = this.offsetHeight

    const scaleAmount = amountToMoveY / elementHeight + 1

    const scaledItemHeight = elementHeight + amountToMoveY
    const heightDifference = scaledItemHeight - elementHeight

    // Check if the parent element is sticky
    const parent = this.parentElement
    const isParentSticky =
      parent && window.getComputedStyle(parent).position === 'sticky'

    if (isParentSticky) {
      const container = parent.parentElement
      const containerStart = getOffsetTop(container)
      const containerEnd =
        containerStart + container.offsetHeight - window.innerHeight
      const totalScrollAmount = containerEnd - containerStart

      let scrollProgress =
        (this.lastKnownY - containerStart) / totalScrollAmount
      scrollProgress = Math.min(Math.max(scrollProgress, 0), 1)

      const stickyFactor = window.BAO.MediaBreakpoints.isXsViewport
        ? 0.75
        : 0.35
      scrollProgress = scrollProgress * stickyFactor + (1 - stickyFactor) / 2

      const transformAmountY = -(
        heightDifference * scrollProgress -
        heightDifference / 2
      )

      this.style.transform = `translate3d(0px, ${transformAmountY}px, 0px) scale(${scaleAmount})`
      return
    }

    const elementStartPoint = getOffsetTop(this) - window.innerHeight
    const elementEndPoint = getOffsetTop(this) + elementHeight

    if (this.lastKnownY <= elementStartPoint) {
      this.style.transform = `translate3d(0px, ${
        amountToMoveY / -2
      }px, 0px) scale(${scaleAmount})`
      return
    }

    if (this.lastKnownY > elementEndPoint) {
      this.style.transform = `translate3d(0px, ${
        amountToMoveY / 2
      }px, 0px) scale(${scaleAmount})`
      return
    }

    const totalScrollAmount = elementEndPoint - elementStartPoint
    const scrollYAsAPercentageOfJourney =
      (this.lastKnownY - elementStartPoint) / totalScrollAmount

    const transformAmountY =
      heightDifference * scrollYAsAPercentageOfJourney - heightDifference / 2

    this.style.transform = `translate3d(0px, ${transformAmountY}px, 0px) scale(${scaleAmount})`
  }
}

if (!customElements.get('parallax-image')) {
  customElements.define('parallax-image', ParallaxImage)
}
